import {Component, Input, OnInit} from '@angular/core';
import {PlacementTestSectionQuestionModel} from '../../../../../models/edu-admin/placement-test.model';
import {SectionQuestionResult} from '../../placement-group-view.component';
import {TranslateService} from '@ngx-translate/core';
import {CultureModel} from '../../../../../models/localization-and-pricing/culture.model';
import {UserModel} from '../../../../../models/authentication/user.model';

@Component({
  selector: 'app-placement-group-skill-card-small',
  templateUrl: './placement-group-skill-card-small.component.html',
  styleUrls: ['./placement-group-skill-card-small.component.css']
})
export class PlacementGroupSkillCardSmallComponent implements OnInit {

  /**
   * Index is used to display number what the skill card is
   * in the ordered list of skills to work on in the placement test
   */
  @Input() index: number;

  /**
   * The number of students are required to show averages for the
   * students in the group.
   */
  @Input() numStudents: number;

  /**
   * We need to get the question of the placement test section question
   */
  @Input() placementSectionQ: PlacementTestSectionQuestionModel;

  /**
   * The aggregated data for the section question where we have
   * aggreated the num failed, num practised and num mastered
   * based on the mastery after the placement test
   */
  @Input() sectionQuestionResult: SectionQuestionResult;

  constructor(public tSv: TranslateService) { }

  static cardWidth(): number {
    return 358;
  }

  static cardHeight(): number {

    return 180;
  }

  ngOnInit() {
  }

  numPassed(): number {

    if (this.sectionQuestionResult) {
      return this.sectionQuestionResult.numPassed();
    }

    return 0;

  }

  numPassedStr(): string {

    return this.numPassed().toString(10);

  }

  numFailedStr(): string {

    if (this.sectionQuestionResult) {

      return this.sectionQuestionResult.numFailed.toString(10);
    }

    return '0';

  }

  numPractisingStr(): string {

    if (this.sectionQuestionResult) {

      return this.sectionQuestionResult.numPractising.toString(10);
    }

    return '0';
  }

  numMasteredStr(): string {

    if (this.sectionQuestionResult) {

      return this.sectionQuestionResult.numMastered.toString(10);
    }

    return '0';

  }

  divideByStudents(value: number): number {

    if (this.numStudents === 0) {
      return 0;
    }

    return value / this.numStudents * 100;

  }

  studentPercentageStr(value: number): string {

    return this.divideByStudents(value).toFixed(0);

  }

  userCulture(): string {

    if (UserModel.getCurrent()) {
      return UserModel.getCurrent().culture;
    }

    return CultureModel.enGB;
  }

}
